import { DisciplineSchedule } from '../../Components/DisciplineSchedule';

export const CowboySilhouetteSchedule = () => {
  return (
    <DisciplineSchedule 
      discipline="COWBOY_SILHOUETTE" 
      disciplineName="Cowboy Silhouette"
    />
  );
};
